import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNote = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4 4C4 2.89688 4.89688 2 6 2H14C15.1031 2 16 2.89688 16 4V16C16 17.1031 15.1031 18 14 18H6C4.89688 18 4 17.1031 4 16V4ZM6 6.5C6 6.775 6.225 7 6.5 7H13.5C13.775 7 14 6.775 14 6.5C14 6.225 13.775 6 13.5 6H6.5C6.225 6 6 6.225 6 6.5ZM6.5 9C6.225 9 6 9.225 6 9.5C6 9.775 6.225 10 6.5 10H13.5C13.775 10 14 9.775 14 9.5C14 9.225 13.775 9 13.5 9H6.5ZM6.5 12C6.225 12 6 12.225 6 12.5C6 12.775 6.225 13 6.5 13H10.5C10.775 13 11 12.775 11 12.5C11 12.225 10.775 12 10.5 12H6.5Z",
		fill: "#0D2976"
	})
});
export default SvgNote;
